import React from "react";
import {css, cx} from "@panda/css";

import {Highlight, Text, TextVariantUnionType} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../helpers/OfferType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    rooms: number;
    offerType: number;
    offerName: string;
    textVariant?: TextVariantUnionType;
    highlightBoldText?: boolean;
    className?: string;
}

export const QWPropertyInfoHeading = (props: IProps) => {
    const {rooms, offerType, offerName, textVariant = "body_copy_1", highlightBoldText, className} = props;
    const flatPlural = pluralize(["pokój", "pokojowe", "pokoi"]);
    const houseFlatPlural = pluralize(["pokój", "pokoje", "pokoi"]);

    const setFlatPluralText = () => {
        switch (offerType) {
            case OfferType.FLAT:
                return `${rooms} ${flatPlural(rooms)}`;
            case OfferType.HOUSE:
                return `${rooms} ${houseFlatPlural(rooms)}`;
            case OfferType.COMMERCIAL:
            default:
                return "";
        }
    };

    const TextContainer = highlightBoldText ? Highlight : React.Fragment;

    return (
        <Text as="div" variant={textVariant} className={cx(textPadding, className)}>
            {getOfferTypeNameCapital(offerType)}{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{setFlatPluralText()}</TextContainer>
            </Text>{" "}
            w inwestycji{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{offerName}</TextContainer>
            </Text>
        </Text>
    );
};

const textPadding = css({
    pt: 3,
    px: 2,
    pb: 1.5
});
import React from "react";
import {css, cx} from "@panda/css";

import {Highlight, Text, TextVariantUnionType} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../helpers/OfferType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    rooms: number;
    offerType: number;
    offerName: string;
    textVariant?: TextVariantUnionType;
    highlightBoldText?: boolean;
    className?: string;
}

export const QWPropertyInfoHeading = (props: IProps) => {
    const {rooms, offerType, offerName, textVariant = "body_copy_1", highlightBoldText, className} = props;
    const flatPlural = pluralize(["pokój", "pokojowe", "pokoi"]);
    const houseFlatPlural = pluralize(["pokój", "pokoje", "pokoi"]);

    const setFlatPluralText = () => {
        switch (offerType) {
            case OfferType.FLAT:
                return `${rooms} ${flatPlural(rooms)}`;
            case OfferType.HOUSE:
                return `${rooms} ${houseFlatPlural(rooms)}`;
            case OfferType.COMMERCIAL:
            default:
                return "";
        }
    };

    const TextContainer = highlightBoldText ? Highlight : React.Fragment;

    return (
        <Text as="div" variant={textVariant} className={cx(textPadding, className)}>
            {getOfferTypeNameCapital(offerType)}{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{setFlatPluralText()}</TextContainer>
            </Text>{" "}
            w inwestycji{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{offerName}</TextContainer>
            </Text>
        </Text>
    );
};

const textPadding = css({
    pt: 3,
    px: 2,
    pb: 1.5
});
